import {
  ACTION_GET_EXPENSE_EXPORT_MODELS,
  ACTION_GET_EXPENSE_EXPORT_MODELS_SUCCESS,
  ACTION_GET_EXPENSE_EXPORT_MODELS_FAILURE,
  ACTION_PUT_EXPENSE_EXPORT_MODEL,
  ACTION_PUT_EXPENSE_EXPORT_MODEL_SUCCESS,
  ACTION_PUT_EXPENSE_EXPORT_MODEL_FAILURE,
} from '../configs/ActionTypes';

const initialState = {
  models: [],
  isLoading: false,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_GET_EXPENSE_EXPORT_MODELS:
      return { ...state, isLoading: true };
    case ACTION_GET_EXPENSE_EXPORT_MODELS_SUCCESS:
      return {
        ...state,
        models: action.payload.payload || [],
        isLoading: false,
      };
    case ACTION_GET_EXPENSE_EXPORT_MODELS_FAILURE:
      return { ...state, isLoading: false };
    case ACTION_PUT_EXPENSE_EXPORT_MODEL:
      return { ...state, isLoading: true };
    case ACTION_PUT_EXPENSE_EXPORT_MODEL_SUCCESS: {
      const updatedModel = action.payload.payload;
      return {
        ...state,
        models: state.models.map((model: any) =>
          model.id === updatedModel.id ? updatedModel : model,
        ),
        isLoading: false,
      };
    }
    case ACTION_PUT_EXPENSE_EXPORT_MODEL_FAILURE:
      return { ...state, isLoading: false };
    default:
      return state;
  }
}